// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1AMW3","addWidgetButton":"Header_addWidgetButton__383gF","dashboardTabs":"Header_dashboardTabs__EsoRe","active":"Header_active__1gHdW"};